/**
 * Swatches selector component
 *
 * @module swatches-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "component-swatches";

if (!customElements.get(customElements.component)) {
  class swatchComponent extends HTMLElement {
    /**
     * Product swatch selector web component.
     *
     * @constructor
     */
    constructor() {
      super();

      window.theme.product
        .loadProduct(this.dataset.handle, true)
        .then((product) => {
          this.product = product;
          this.render(product);
        });

      this.placement = this.dataset.placement;
      this.productForm = this.closest('form');
      this.tooltipPricingTable = this.productForm.querySelector('tooltip-pricing-table');
    }

    /**
     * Render component in the DOM
     *
     * @param {object} product Product data.
     * @returns {undefined}
     */
    render(product) {
      this.selectFirstVariantAvailable(product);

      this.initEvents(product);
    }

    /**
     * Get component template
     *
     * @returns {string} Component HTML template.
     */
    getTemplate() {
      return "{{content}}";
    }

    /**
     * Init component events.
     *
     * @param {object} product Product data.
     * @returns {undefined}
     */
    initEvents(product) {
      // On swatch change
      if (product.variants.length === 1) {
        this.loadProductNameMinPackQty();

        // prevent the main product SKU on PDPs from changing
        if (this.dataset.placement === "product-single") {
          this.skuChangePdp(product.variants[0].sku);
        }
      }

      this.querySelectorAll("[data-swatch-input]").forEach((element) => {
        element.addEventListener("change", (event) => {
          this.onSwatchChange(event.target, product);
        });
        element.addEventListener("click", (event) => {
          this.onSwatchClicked(event.target, product);
        });
      });

      let variantSelector = document.querySelector(
        'variant-selector[data-handle="' + this.dataset.handle + '"]'
      );

      if (variantSelector) {
        // On variant selector ready
        variantSelector.addEventListener("ready", (event) => {
          variantSelector
            .querySelector("select")
            .addEventListener("change", (event) => {
              this.updateSwatchValues();
            });

          this.selectFirstVariantAvailable(product);
          this.disableOutOfStockVariants();
          this.loadProductNameMinPackQty();
        });

        // After variant selector ready event
        if (variantSelector.classList.contains("ready")) {
          variantSelector
            .querySelector("select")
            .addEventListener("change", (event) => {
              this.updateSwatchValues();
            });

          this.selectFirstVariantAvailable(product);
          this.disableOutOfStockVariants();
        }
      }
    }

    /**
     * Load swatch inputs from a product
     *
     * @param {object} product Product data.
     * @returns {undefined|boolean}
     */
    loadSwatches(product) {
      if (!window.theme.product.hasVariants(product)) return false;

      product.options.forEach((option) => {
        if (this.getImageSwatchOptions().includes(option.name.toUpperCase())) {
          this.loadSwatchImage(option, product);
        } else {
          this.loadSwatchText(option, product);
        }
      });
    }


    loadProductData() {
      console.log('this.dataset.handle:', this.dataset.handle);

      window.theme.product
        .loadProduct(this.dataset.handle, true)
        .then((product) => {
          this.product = product;
          this.render(product);
        });

      console.log('loadProductData:', this.product);
    }

    /**
     * Get array of the custom option to be used as an image swatch.
     *
     * @returns {Array} Array of the custom options.
     */
    getImageSwatchOptions() {
      if (typeof this.imageSwatchOptions == "undefined") {
        this.imageSwatchOptions = this.dataset.imageOptions
          ? this.dataset.imageOptions.toUpperCase().split(",")
          : "";

        return this.imageSwatchOptions;
      } else {
        return this.imageSwatchOptions;
      }
    }

    /**
     * Get swatch element from DOM.
     *
     * @returns {object} Swatch element.
     */
    getSwatchElement(optionName) {
      return this.querySelector(
        '[data-option="' + optionName.replaceAll(" ", "-") + '"]'
      );
    }

    /**
     * Render swatch as an image.
     *
     * @param {object} product Product data.
     * @param {object} option Product option data.
     * @returns {undefined|boolean}
     */
    loadSwatchImage(option, product) {
      let element = this.getSwatchElement(option.name),
        swatches = window.theme.swatches.getSwatches(product, option.name),
        label = this.getSwatchLabelTemplate(),
        rand = Math.floor(Math.random() * 100),
        finalHtml = "";

      element.dataset.type = "image";

      label = label.replaceAll("{{ option_name }}", option.name);
      label = label.replaceAll("{{ index }}", option.position);

      option.values.forEach((value) => {
        let html = this.getSwatchImageTemplate(),
          image = swatches.find((item) => {
            return item.value == value;
          }),
          id =
            "option-" +
            rand +
            "-" +
            option.name.toLowerCase().replaceAll(" ", "-") +
            "-" +
            value.toLowerCase().replaceAll(" ", "-");

        if (!image.src) return false;

        html = html.replaceAll("{{ value }}", value);
        html = html.replaceAll("{{ name }}", option.name);
        html = html.replaceAll("{{ id }}", id);
        html = html.replaceAll("{{ src }}", image.src);

        finalHtml = finalHtml + html;
      });

      element.innerHTML = label + finalHtml;
    }
    /*grab images as variants*/
    /*
            getProductVariantFirstImage(product, optionValue) {
                const image = product.images.find(image => {
                    const imageOptionAltText = image.alt.split('/')[1];
                    if (!imageOptionAltText) return false;
                    return imageOptionAltText.toLowerCase().includes(optionValue.toLowerCase())
                });

                return image || { src: window.theme.placeholder_image_url };
            }
            */

    /**
     * Render swatch as a text.
     *
     * @todo Merge this fuction with loadSwatchImage.
     * @param {object} product Product data.
     * @param {object} option Product option data.
     * @returns {undefined|boolean}
     */
    loadSwatchText(option, product) {
      let element = this.getSwatchElement(option.name),
        label = this.getSwatchLabelTemplate(),
        rand = Math.floor(Math.random() * 100),
        finalHtml = "";

      if (element) {
        let additionalClass = option.values.length == 0 ? "hidden" : "";

        element.dataset.type = "text";

        label = label.replaceAll("{{ option_name }}", option.name);
        label = label.replaceAll("{{ index }}", option.position);

        option.values.forEach((value) => {
          let html = this.getSwatchTextTemplate(),
            id =
              "option-" +
              rand +
              "-" +
              option.name.toLowerCase().replaceAll(" ", "-") +
              "-" +
              value.toLowerCase().replaceAll(" ", "-");

          html = html.replaceAll("{{ value }}", value);
          html = html.replaceAll("{{ name }}", option.name);
          html = html.replaceAll("{{ id }}", id);
          html = html.replaceAll("{{ additionalClass }}", additionalClass);

          finalHtml = finalHtml + html;
        });

        element.innerHTML = label + finalHtml;
      }
    }

    /**
     * Get swatch label html template.
     *
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchLabelTemplate() {
      return `<div class="swatch-label" style="font-size: 10px;"><span class="uppercase font-bold text-[#424244]">${
        !["product-card", "product-card-collection"].includes(this.placement)
          ? "SELECT A "
          : ""
      }{{ option_name }}</span><strong class="font-light text-[#424244]" data-swatch-label="{{ option_name }}">No {{ option_name }} Selected</strong></div>`;
    }

    /**
     * Get swatch image html template.
     *
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchImageTemplate() {
      return (
        '<div class="swatch-container">' +
        '<div class="swatch swatch--image">' +
        '<input type="radio" id="{{ id }}" name="{{ name }}" value="{{ value }}" aria-label="{{ value }}" data-swatch-input="{{ name }}">' +
        '<label for="{{ id }}">{{ value }}</label>' +
        `<img src="{{ src }}" width="70" height="70" alt="{{ value }}" onerror="this.src='${window.theme.placeholder_image_url}'" />` +
        "</div>" +
        '<div class="swatch-variant">' +
        "<span>{{ value }}</span>" +
        "</div>" +
        "</div>"
      );
    }

    /**
     * Get swatch text html template.
     *
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchTextTemplate() {
      return (
        '<div class="swatch swatch--text {{ additionalClass }}">' +
        '<input type="radio" id="{{ id }}" name="{{ name }}" value="{{ value }}" aria-label="{{ value }}" data-swatch-input="{{ name }}">' +
        '<label for="{{ id }}">{{ value }}</label>' +
        "</div>"
      );
    }

    /**
     * On swatch change.
     *
     * @param {object} swatchInput Swatch input dom element.
     * @param {object} product Product data.
     * @returns {undefined}
     */
    onSwatchChange(swatchInput, product) {
      this.updateOptionLabel(swatchInput);

      let variant = this.getSelectedVariant(product);

      if (variant) {
        this.skuChangePdp(variant.sku);
        this.updateProductNameMinPackQty(variant.id);
        this.triggerSwatchChangeEvent(variant);
        this.updateQuantitySelector(variant);

        if (this.tooltipPricingTable) {
          this.tooltipPricingTable.updatePricingTable(variant.id);
        }
      }

      this.disableOutOfStockVariants();
    }

    updateQuantitySelector(variant) {
      if (!variant || this.product.variants_metafields === undefined) {return false}
      const selectedVariantMetafieldData = this.product.variants_metafields.filter(v => v.variant_id === variant.id)[0];
      let formContainer = this.closest('form[action="/cart/add"]');
      if (!formContainer) {return false}
      let quantitySelector = formContainer.querySelector('quantity-selector');

      if (!quantitySelector || !selectedVariantMetafieldData) {return false}
      quantitySelector.setAttribute('data-variant-id', variant.id);
      quantitySelector.setAttribute('data-case-qty', selectedVariantMetafieldData.metafields.min_pack_qty);
    }

    onSwatchClicked(swatchInput, product) {
      let event = new CustomEvent("swatch-clicked", {
        detail: {
          element: swatchInput,
          product: this.product,
        },
      });

      this.dispatchEvent(event);
    }

    loadProductNameMinPackQty() {
      if (this.product) {
        let firstAvailableOption = document.querySelector(
          'variant-selector[data-handle="' +
            this.dataset.handle +
            '"] option[data-enabled]'
        );
        if (firstAvailableOption) {
          let variant = this.product.variants.find((item) => {
            return item.id == firstAvailableOption.dataset.variantId;
          });

          if (variant) {
            this.updateProductNameMinPackQty(variant.id);
          }
        }
      }
    }

    updateProductNameMinPackQty(variantId) {
      if (this.product.variants_metafields === undefined) return;
      const variantMetafields = this.product.variants_metafields.find(
        (variant) => variant.variant_id === variantId
      );
      const productTitle = document.querySelectorAll(
        `[data-product-title-min-pack-qty="${this.product.id}"]`
      );
      productTitle.forEach((element) => {
        const minPackQty = (variantMetafields.metafields.min_pack_qty ?? "")
          .match(/\d+/g)
          ?.join("");
        /*console.log('metafields.min_pack_qty:', variantMetafields.metafields.min_pack_qty)
        console.log('minPackQty:', minPackQty);*/

        if (minPackQty) {
          if (parseInt(minPackQty) === 1) {
            element.innerHTML = `/ Unit`;
          } else {
            element.innerHTML = `/ Case | ${minPackQty} Units`;
          }
        } else {
          element.innerHTML = "";
        }
      });
    }

    skuChangePdp(sku) {
      // do nothing if the sku does not exist
      if (!sku) return;

      const componentAddToCart = this.closest('component-addtocart');
      const skuElement = componentAddToCart.querySelector("[data-sku]");
      if (skuElement) skuElement.innerHTML = sku;
    }

    /**
     * Get selected variant from swatch inputs.
     *
     * @param {object} product Product data.
     * @returns {object} Product variant data.
     */
    getSelectedVariant(product) {
      // Create object with selected options
      let selectedOptions = {};

      // Save the selected options in to the object
      this.querySelectorAll("[data-option]").forEach((element) => {
        let input = element.querySelector("[data-swatch-input]:checked");

        if (input) {
          selectedOptions["option" + element.dataset.position] = input.value;
        }
      });

      // Find a product variant based on the selected options
      return product.variants.find((item) => {
        return (
          item.option1 == selectedOptions.option1 &&
          item.option2 == selectedOptions.option2 &&
          item.option3 == selectedOptions.option3
        );
      });
    }

    /**
     * Get variant selector web component.
     *
     * @returns {object} Variant selector web component from DOM.
     */
    getVariantSelector() {
      if (!this.dataset.handle) return;

      return document.querySelector(
        'variant-selector[data-handle="' + this.dataset.handle + '"] select'
      );
    }

    /**
     * Update swatch option label with the current selected value.
     *
     * @param {object} input Swatch input.
     * @returns {undefined}
     */
    updateOptionLabel(input) {
      if (!input) return;
      let relatedOptionLabel = this.querySelector(`label[for="${input.name}"]`);
      if (!relatedOptionLabel) return;

      relatedOptionLabel.innerHTML = input.value ?? `No ${input.name.toLowerCase()} Selected`;
    }

    /**
     * Select the first variant available from a product in the variant selector component.
     *
     * @param {object} product Product data.
     * @returns {undefined}
     */
    selectFirstVariantAvailable(product) {
      if (product.variants.length == 1) {
        let firstAvailableOption = document.querySelector(
          'variant-selector[data-handle="' +
            this.dataset.handle +
            '"] option[data-enabled]'
        );

        if (firstAvailableOption) {
          let variant = product.variants.find((item) => {
            return item.id == firstAvailableOption.dataset.variantId;
          });

          this.selectVariant(variant);
        }
      }
    }

    /**
     * Select variant from a product in the variant selector component.
     *
     * @todo Try to improve this code to reduce the code quantity.
     * @param {object} variant Product variant data.
     * @returns {undefined}
     */
    selectVariant(variant) {
      if (variant) {
        let inputOption1 = this.querySelector(
          '[data-option][data-position="1"] input[value="' +
            variant.option1 +
            '"]'
        );

        if (inputOption1) {
          inputOption1.checked = true;
          //this.updateOptionLabel(inputOption1);
        }

        let inputOption2 = this.querySelector(
          '[data-option][data-position="2"] input[value="' +
            variant.option2 +
            '"]'
        );

        if (inputOption2) {
          inputOption2.checked = true;
          //this.updateOptionLabel(inputOption2);
        }

        let inputOption3 = this.querySelector(
          '[data-option][data-position="3"] input[value="' +
            variant.option3 +
            '"]'
        );

        if (inputOption3) {
          inputOption3.checked = true;
          //this.updateOptionLabel(inputOption3);
        }
      }
    }

    /**
     * Disable out of stock variant swatches.
     *
     * @returns {undefined}
     */
    disableOutOfStockVariants() {
      let firstSelectedOption = {},
        secondSelectedOption = {},
        variantSelector = this.getVariantSelector();

      this.querySelectorAll("[data-option]").forEach((element) => {
        element.querySelectorAll("[data-swatch-input]").forEach((input) => {
          let selector = "",
            inputValue = input.value.replaceAll(" ", "-"),
            inputName = input.name.replaceAll(" ", "-");

          switch (element.dataset.position) {
            case "1":
              selector =
                "[data-swatches-option-" +
                inputName +
                '="' +
                inputValue +
                '"][data-enabled]';

              if (input.checked) {
                firstSelectedOption.name = inputName;
                firstSelectedOption.value = inputValue;
              }

              break;

            case "2":
              selector =
                "[data-swatches-option-" +
                firstSelectedOption.name +
                '="' +
                firstSelectedOption.value +
                '"][data-swatches-option-' +
                inputName +
                '="' +
                inputValue +
                '"][data-enabled]';

              if (input.checked) {
                secondSelectedOption.name = inputName;
                secondSelectedOption.value = inputValue;
              }

              break;

            default:
              selector =
                "[data-swatches-option-" +
                firstSelectedOption.name +
                '="' +
                firstSelectedOption.value +
                '"][data-swatches-option-' +
                secondSelectedOption.name +
                '="' +
                secondSelectedOption.value +
                '"][data-swatches-option-' +
                inputName +
                '="' +
                inputValue +
                '"][data-enabled]';

              break;
          }

          let optionsVariantSelector =
            variantSelector.querySelectorAll(selector);

          if (optionsVariantSelector.length == 0) {
            input.classList.add("disabled");
          } else {
            input.classList.remove("disabled");
          }
        });
      });
    }

    /**
     * Update swatch inputs by variant id.
     *
     * @param {integer} variantId Variant id.
     * @returns {undefined}
     */
    update(variantId) {
      let variant = window.theme.product.getVariant(variantId, this.product);

      this.selectVariant(variant);
    }

    /**
     * Trigger variant swatch change event.
     *
     * @param {object} variant Product variant data.
     * @returns {object} Event swatch-change.
     */
    triggerSwatchChangeEvent(variant) {
      let event = new CustomEvent("swatch-change", {
        detail: {
          product: this.product,
          variantId: variant.id,
          variant: variant,
        },
      });

      this.dispatchEvent(event);

      return event;
    }

    disable() {
      this.classList.add("disabled");
    }

    enable() {
      this.classList.remove("disabled");
    }
  }

  customElements.define(customElements.component, swatchComponent);
}
